import {$, HttpIgnore, Model, ResponseFill} from 'simpli-web-sdk'
import AreaDeRisco from '@/model/resource/AreaDeRisco'

@HttpIgnore()
export default class PersisAreaDeRiscoRequest extends Model {
  readonly $name: string = 'PersistAreaDeRiscoRequest'

  @ResponseFill()
  areaDeRisco: AreaDeRisco[] = []

  async persistAreaDeRisco(spinner = 'persistAreaDeRiscoUpload') {
    const fetch = async () => {
      return await this.POST('/user/area-de-risco-upload', this)
    }

    return await $.await.run(fetch, spinner)
  }
}
